module.exports = __webpack_public_path__ + "static/media/31-4.5272f33a.mp3";